import * as React from "react";
import {useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IScreens} from "IncompleteInfoV2/interface";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import Okyc from "myshubhlife-component/Okyc";
import {updateSubStatuses} from "IncompleteInfoV2/api";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import {history} from "load/store";
import Loading from "components/loading";
import {COLOR} from "utils/variables";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    applicationId: number;
}

const AadhaarOkyc = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (status: boolean) => {
      if (status) {
        try {
          setLoading(true);
          const removeStatus = await updateSubStatuses(props.applicationId,
            props.screens[ScreenNames.AADHAAR_OKYC].subStatuses);
          if (removeStatus.status === 200) {
            props.dispatch(showToast(COLOR.GREEN, `${pageTitle.aadhaarOKYC} updated successfully`));
            props.dispatch(removeCompletedSubStatus(ScreenNames.AADHAAR_OKYC));
            setLoading(false);
            history.goBack();
          }
        } catch (err) {
          setLoading(false);
        }
      }
    };
    return (
        <>
          <Loading active={loading} msg="Please wait while saving.." />
          <Okyc kycStatus={handleSubmit}/>
        </>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(AadhaarOkyc);
